var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconLogin01 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 21 22"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "#000",
  fillRule: "evenodd",
  clipRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M5.8.384h14.734v21.233H5.8v-5.742h1.734v4.009H18.8V2.117H7.534v4.008H5.8z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M15.237 11.86H.022v-1.732h15.215z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m10.256 14.846 3.852-3.852-3.852-3.852 1.226-1.225 5.077 5.077-5.077 5.078z"
}))));
export default SvgIconLogin01;